import { useId } from 'react';
import { useTranslation } from 'react-i18next';

export type MyDrawingsStatus = 'active' | 'archived';

interface MyDrawingsFilterProps {
  readonly status: MyDrawingsStatus;
  readonly onChange: (status: MyDrawingsStatus) => void;
}

// #837 (owner, #836) -- the My drawings feed's filter: Active (the default) or Archived. It took
// over from the File drawer's Recent drawings list, which was the only place archived drawings
// could be found; an archived card offers Restore.
export function MyDrawingsFilter({ status, onChange }: MyDrawingsFilterProps) {
  const { t } = useTranslation();
  const name = useId();
  return (
    <fieldset className="search-results-filters my-drawings-filter" data-testid="my-drawings-filter">
      <legend>{t('myDrawings.filter.legend')}</legend>
      {(['active', 'archived'] as const).map((value) => (
        <label key={value}>
          <input type="radio" name={name} checked={status === value} onChange={() => onChange(value)} />
          {t(`myDrawings.filter.${value}`)}
        </label>
      ))}
    </fieldset>
  );
}
